module.exports = __webpack_public_path__ + "static/media/BUKloader.4e7dbcc3.gif";